var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossSell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#314e55",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 19.5v-19l13 9.5z",
    fill: "#5ecb66",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 7h-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 13h-24"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 46 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 19.5v-19l13 9.5z",
    fill: "#e65f58",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 7h-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 13h-24"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m47.0106354 26h-47.0106354",
    strokeDasharray: 4,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSell);
export default __webpack_public_path__ + "static/media/crossSell.dd3cec527bd04f8065bb216bfe46c95c.svg";
export { ForwardRef as ReactComponent };